import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
} from 'semantic-ui-react';
import SpecificationTable from '../../components/SpecificationTable';


export default class MultiUnitSpecification extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
    open: PropTypes.bool,
    unit: PropTypes.oneOfType([
      PropTypes.object.isRequired,
    ]).isRequired,
  }
  handleOnChange = (data) => {
    if (this.props.onChange) {
      this.props.onChange(data);
    }
  }
  handleOnDone = (e) => {
    e.preventDefault();
    if (this.props.onDone) {
      this.props.onDone(e);
    }
  }
  render() {
    return (
      <Modal
        closeOnEscape={false}
        closeOnDimmerClick={false}
        open={this.props.open === true}
        size="small"
      >
        <Modal.Header>Manage Specification for {this.props.unit.reference}</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <SpecificationTable
              type="units"
              editable
              isEditing
              hideButton
              data={this.props.unit.specifications}
              onChange={this.handleOnChange}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.handleOnDone} content="Confirm" inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/MultiUnitSpecification.jsx